module.exports = {
  contact: {
    badge: "Iletisim",
    title: "Iletisim",
    subtitle: "Minimal iletisim sayfasi.",
    summaryTitle: "Baglanti",
    summaryText: "Bu sayfa daha sonra gercek iletisim bilgileriyle doldurulabilir.",
    summaryPoints: ["E-posta", "Telefon", "Telegram"],
    cardsTitle: "Kanallar",
    cardsSubtitle: "Minimal iletisim seti.",
    cards: [
      { icon: "fas fa-envelope", title: "Email", text: "demo@smartteamdev.ru" },
      { icon: "fas fa-phone-volume", title: "Telefon", text: "+7 (495) 123-45-67" },
      { icon: "fab fa-telegram-plane", title: "Telegram", text: "@smartteamdev" }
    ],
    listTitle: "Sonraki adimlar",
    listSubtitle: "Gelecek icerik icin basit liste.",
    listItems: ["Yaz", "Arama", "Demo"],
    stats: [
      { value: "24s", label: "yanit" },
      { value: "3", label: "kanal" }
    ],
    ctaTitle: "Talep gonder",
    ctaText: "Bu blok sonra form veya CTA icin kullanilabilir.",
    primaryHref: "mailto:demo@smartteamdev.ru",
    primaryLabel: "Yaz",
    secondaryHref: "/pages/portal",
    secondaryLabel: "Portal",
    detailsTitle: "",
    details: [
      { icon: "fas fa-envelope", label: "", value: "", href: "mailto:" },
      { icon: "fas fa-phone-volume", label: "", value: "", href: "tel:" },
      { icon: "fab fa-telegram-plane", label: "", value: "", href: "" }
    ],
    formTitle: "",
    formText: ""
  }
};